<script setup lang="ts">
import { watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { definePage } from "unplugin-vue-router/runtime";
import { useAbility } from "@/api/models/auth/ability";
import Loading from "@/components/shared/Loading.vue";
import { billingPagePath, readBillingRights } from "@/composables/shared/billingAccess";
import { useBillingOwner } from "@/composables/shared/useBillingOwner";

definePage({
  meta: {
    title: "generic.fields.sections.billing",
    checkPrivileges: () => {
      const { can } = useAbility();
      const rights = readBillingRights(can);
      return rights.canMsoBilling || rights.canCompanyBilling;
    },
  },
});

const route = useRoute();
const router = useRouter();
const { isLoading, firstOpenPage } = useBillingOwner();

watch(
  () => (isLoading.value ? undefined : firstOpenPage.value),
  (target, previous) => {
    if (!target || previous) return;
    void router.replace({ path: billingPagePath(target), query: route.query });
  },
  { immediate: true }
);
</script>

<template>
  <loading
    :size="32"
    class="tw:my-10!"
  />
</template>
